export const oneOneOneReactQueryKeys = {
  oneOnOneInstanceDetails: 'oneOnOneInstanceDetails',
  oneOnOneAgenda: 'oneOnOneAgenda',
  oneOnOneActionItems: 'oneOnOneActionItems',
  oneOnOneNotes: 'oneOnOneNotes',
  oneOnOneRating: 'oneOnOneRating',
  oneOnOneAgendaLibrary: 'oneOnOneAgendaLibrary',
  existingOneonOneList: 'existingOneonOneList',
  agendaRecommendationsApi: 'agendaRecommendationsApi',
  botRecommendedData: 'botRecommendedData',
  relationToLoggedInEmployee: 'relationToLoggedInEmployee',
};
